import { PrinterIcon } from '@heroicons/react/24/outline'
import Download from '../../../../components/icons/download'
import Pdf from '../../../../components/icons/pdf'
import { ChartListResponse, ChartStatusColorEnum } from '../../../../models/chart'
import useAdminManageClerk from '../hooks/use-admin-manage-clerk'
import { useNavigate } from 'react-router-dom'

type AdminManageClerkChartFileProps = {
	chart: ChartListResponse;
	tab?: string;
}

export const AdminManageClerkChartFile = (props: AdminManageClerkChartFileProps) => {
	const { chart, tab } = props;
	const state = useAdminManageClerk();
	const navigate = useNavigate();

	const handleElectionType = (electionType: string) => {
		if (electionType === 'non partisan') {
			return 'non-partisan'
		}
		if (electionType === 'general election') {
			return 'general'
		}
		if (electionType === 'partisan primary') {
			return 'partisan'
		}
		if (electionType === 'presidential primary') {
			return 'presidential'
		}
	}
	return (
		<div className='flex flex-col w-3/4 mx-10 bg-white rounded-xl'>
			<div className='flex flex-row justify-end -mt-5 -mr-2'>
				<div
					className='mr-3 rounded-full cursor-pointer bg-secondary-lightblue'
					onClick={() => state.downloadChart(chart.id, "download")}
				>
					<Download className='w-6 m-3' />
				</div>
				<div
					className='bg-gray-300 rounded-full cursor-pointer'
					onClick={() => state.downloadChart(chart.id, "print")}
				>
					<PrinterIcon className='w-6 m-3 text-gray-700' />
				</div>
			</div>
			<div className='flex flex-row items-center justify-start px-3 mb-3'>
				<Pdf className='w-6 m-3' />
				<p
					className='mr-3 text-lg font-semibold font-sourceSansPro hover:cursor-pointer'
					onClick={() => {
						navigate(`/elections/${handleElectionType(chart.electionType.name.toLowerCase())}/edit/${chart.id}`);
					}}>
					{`${chart.municipality}, ${chart.precinct} - ${chart.downloadLink.split('/')[3]}`}
				</p>
				<p
					className={`${ChartStatusColorEnum[
						chart.status as keyof typeof ChartStatusColorEnum
					]
						} px-1 rounded-sm uppercase text-xs ${tab === 'Printed' ? ChartStatusColorEnum[
							tab as keyof typeof ChartStatusColorEnum
						] : ''}`}
				>
					{chart.status === "InProgress" ? "In Progress" : chart.status}
				</p>
			</div>
		</div>
	)
}
